import { Button, ButtonGroup } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";

import { arrayMove } from "core/util/ArrayUtils";

interface IArrayItemToolbarProps<T> {
	arr: T[];
	itemIndex: number;

	onChange?: (arr: T[]) => void;
	onSort?: (o: T, prevIndex: number, nextIndex: number) => void;
	onRemove?: (o: T, index: number) => void;

	children?: JSX.Element; // additonal buttons
	remove?: boolean; // allow users to remove items (default true)
	sort?: boolean; // default true
	minimal?: boolean;
	small?: boolean;
}

export default function ArrayItemToolbar<T = any>(props: IArrayItemToolbarProps<T>) {

	const {
		arr = [],
		children,
		itemIndex,
		minimal = true,
		remove = true,
		sort = true,
		small = true,
		onChange,
		onSort,
		onRemove
	} = props;

	return (
		<ButtonGroup minimal={minimal}>

			{children}

			{
				sort && (
					<React.Fragment>
						<Button
							small={small}
							icon={IconNames.CHEVRON_UP}
							disabled={itemIndex < 1}
							onClick={() => {

								if (onSort) {
									onSort(arr[itemIndex], itemIndex, itemIndex - 1);
								}

								if (onChange) {
									onChange(arrayMove([...arr], itemIndex, itemIndex - 1));
								}
							}}
						/>
						<Button
							small={small}
							icon={IconNames.CHEVRON_DOWN}
							disabled={itemIndex >= arr.length - 1}
							onClick={() => {

								if (onSort) {
									onSort(arr[itemIndex], itemIndex, itemIndex + 1);
								}

								if (onChange) {
									onChange(arrayMove([...arr], itemIndex, itemIndex + 1));
								}
							}}
						/>
					</React.Fragment>
				)
			}

			{
				remove && (
					<Button
						small={small}
						icon={IconNames.SMALL_CROSS}
						onClick={() => {

							if (onRemove) {
								onRemove(arr[itemIndex], itemIndex);
							}

							if (onChange) {
								onChange(arr.filter((_, i) => i !== itemIndex));
							}
						}}
					/>
				)
			}

		</ButtonGroup>
	);
}



// WEBPACK FOOTER //
// ./src/common/form/common/ArrayItemToolbar.tsx